import React, { Component } from 'react'
import { gql } from 'apollo-boost'
import { graphql, withApollo } from 'react-apollo'
import moment from 'moment-timezone'
import { withRouter } from 'react-router'

import Fab from '@material-ui/core/Fab'
import Icon from '@material-ui/core/Icon'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'


class PickupSummary extends Component {

  render() {
    const ticketPickup = this.props.ticketPickup
    const shows = this.props.shows

    const name = (<a href={'/pickup/' + ticketPickup.id}>{ticketPickup.name}</a>)
    const directions = ticketPickup.directions

    const now = moment().format()
    const filteredShows = shows.filter(show => show.runDateStart <= now)
                                    .filter(show => show.runDateEnd >= now)
                                    .filter(show => !show.isForOffBroadway)
                                    .map(show => (<a href={'/show/' + show.id}
                                                     key={show.id}>
                                                  {show.shortName}
                                                 </a>))

    const showEntries = []
    filteredShows.forEach((show, idx) => {
      showEntries.push(show)
      if (idx !== shows.length - 1) { showEntries.push(', ') }
    })

    return (
      <TableRow style={{ height: '80px' }}>
        <TableCell>{name}</TableCell>
        <TableCell>{directions}</TableCell>
        <TableCell style={{ whiteSpace: 'normal' }}>{showEntries}</TableCell>
      </TableRow>
    )
  }
}


class PickupList extends Component {

  state = { }

  _getItemsToRender = () => {
    return this.props.ticketPickupsListQuery.ticketPickupsList.items
  }

  async _handleClickNew() {
    try {
      const result = await this.props.client.mutate({
        mutation: TICKET_PICKUP_CREATE_MUTATION,
      })

      this.props.history.push(`/pickup/${result.data.ticketPickupCreate.id}`)
    } catch(err) {
      alert(`Unable to create ticket pickup: ${err.message}`)
    }
  }

  render() {
    if (this.props.ticketPickupsListQuery && this.props.ticketPickupsListQuery.loading) {
      return <div>Loading</div>
    }

    if (this.props.ticketPickupsListQuery && this.props.ticketPickupsListQuery.error) {
      return <div>Error</div>
    }

    const itemsToRender = this._getItemsToRender()

    return (
      <div>
        <div>
          <h1 style={{ display: 'inline-block' }}>Evening Ticket Pickup</h1>
          <Fab style={{ marginLeft: '10px' }}
               onClick={() => { this._handleClickNew() }}>
            <Icon className="fa fa-plus-circle" />
          </Fab>
        </div>

        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Directions</TableCell>
                <TableCell>Shows</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {itemsToRender.map((obj, index) => (
                <PickupSummary key={obj.id} ticketPickup={obj} shows={obj.shows.items}/>
              ))}
            </TableBody>
          </Table>
        </Paper>

        <h1>Matinee Ticket Pickups</h1>
        <Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Directions</TableCell>
                <TableCell>Shows</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {itemsToRender.map((obj, index) => (
                <PickupSummary key={obj.id} ticketPickup={obj} shows={obj.matineeShows.items}/>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    )
  }
}

const TICKET_PICKUPS_LIST_QUERY = gql`
  query TicketPickupsListQuery {
    ticketPickupsList {
      items {
        id
        name
        directions

        matineeShows {
          items {
            id
            isForOffBroadway
            shortName
            runDateEnd
            runDateStart
          }
        }

        shows {
          items {
            id
            isForOffBroadway
            shortName
            runDateEnd
            runDateStart
          }
        }
      }
    }
  }
`

const TICKET_PICKUP_CREATE_MUTATION = gql`
  mutation TicketPickupCreateMutation {
    ticketPickupCreate(data: {
      name: "Fill me out"
      directions: "Fill me out"
    }) {
      id
    }
  }
`


export default withRouter(withApollo(graphql(TICKET_PICKUPS_LIST_QUERY, {
  name: 'ticketPickupsListQuery',
  options: () => {
    return {
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
    }
  }
})(PickupList)))
